import { render } from "./TableDetail.vue?vue&type=template&id=39cebade&scoped=true"
import script from "./TableDetail.vue?vue&type=script&lang=js"
export * from "./TableDetail.vue?vue&type=script&lang=js"

import "./TableDetail.vue?vue&type=style&index=0&id=39cebade&scoped=true&lang=css"

import exportComponent from "/var/www/xserenedestiny/DuangdeeLiveAdmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39cebade"]])

export default __exports__